var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStatisticIcon = function SvgStatisticIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "menu-item-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 51097"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20893",
    fill: "none",
    d: "M0 0h46v46H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 15.647a1.225 1.225 0 0 0-1.225 1.225v12.254a1.226 1.226 0 1 0 2.451 0V16.873A1.225 1.225 0 0 0 23 15.647ZM16.873 23a1.225 1.225 0 0 0-1.226 1.225v4.9a1.226 1.226 0 1 0 2.451 0v-4.9A1.225 1.225 0 0 0 16.873 23Zm12.253-2.453a1.225 1.225 0 0 0-1.225 1.225v7.352a1.226 1.226 0 1 0 2.451 0v-7.35a1.225 1.225 0 0 0-1.226-1.227Zm2.45-9.8H14.423a3.676 3.676 0 0 0-3.676 3.676v17.153a3.676 3.676 0 0 0 3.676 3.676h17.153a3.676 3.676 0 0 0 3.676-3.676V14.423a3.676 3.676 0 0 0-3.676-3.676Zm1.225 20.829a1.225 1.225 0 0 1-1.225 1.225H14.423a1.225 1.225 0 0 1-1.225-1.225V14.423a1.225 1.225 0 0 1 1.225-1.225h17.153a1.225 1.225 0 0 1 1.225 1.225Z"
  }))));
};
export default SvgStatisticIcon;